const crypto = require('crypto')

export const stringToUUID = (str) => {
  // Validate input
  if (typeof str !== 'string') {
    throw new Error('Input must be a string')
  }

  // Create a SHA-256 hash of the string
  const hash = crypto.createHash('sha256').update(str).digest('hex')

  // Use the first 16 bytes of the hash to create a UUID
  let i = 0 // Initialize index
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = parseInt(hash[i++], 16) % 16 // Use the current index of the hash
    const v = c === 'x' ? r : (r & 0x3) | 0x8 // Set the version to 4
    return v.toString(16)
  })

  return uuid
}
